import { Box } from '@mui/material';

export const GeneralLedger = () => {
  return <Box sx={{ flex: 1 }}>General legder</Box>;
};
